module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/263.7c2b5df5.png";